import React, { useContext, useEffect, useRef } from 'react';

import styled from '@emotion/styled';

import { WhatIsNewContentDataInterface } from './WhatIsNewContentData';
import { WhatIsNewModalContext } from './WhatIsNewModalProvider';

interface WhatIsNewContentSlideProps {
  title: string;
  description: string;
  index: number;
}

const WhatIsNewContentSlide: React.FC<WhatIsNewContentSlideProps> = ({
  title,
  description,
  index,
}) => {
  const { registerSlideHeight } = useContext(WhatIsNewModalContext);

  const slideRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = slideRef.current;
    if (!el) return;
    const observer = new ResizeObserver(() => {
      registerSlideHeight(index, el.offsetHeight);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [index, registerSlideHeight]);

  return (
    <ContainerWrapper ref={slideRef}>
      <Container>
        <ContentArea>
          <ContentHeader>{title}</ContentHeader>
          <ContentBody>{description}</ContentBody>
        </ContentArea>
      </Container>
    </ContainerWrapper>
  );
};

interface WhatIsNewContentProps {
  data: WhatIsNewContentDataInterface[];
}

const WhatIsNewContent: React.FC<WhatIsNewContentProps> = ({ data }) => {
  return (
    <>
      {data.map((item: WhatIsNewContentDataInterface, index: number) => (
        <WhatIsNewContentSlide key={index} {...item} index={index} />
      ))}
    </>
  );
};

export default WhatIsNewContent;

const ContainerWrapper = styled.div`
  /* border: 1px solid green; */
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  /* border: 1px solid red; */
  height: 100%;
  gap: 24px;

  width: 551px;
`;

const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ContentHeader = styled.h3`
  font-size: 48px;
  line-height: 120%;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.logirateBlack};

  @media (max-width: 480px) {
    font-size: 28px;
    width: 300px;
  }
`;

const ContentBody = styled.p`
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-weight: 500;
  font-size: 16px;
  line-height: 160%;

  @media (max-width: 480px) {
    font-size: 14px;
    width: 300px;
  }
`;
